
/* This function is specifically designe to work with font-awesome classes and it
adds <i> tags with specified classes to create icons in the React-Carousel controls */
export const detailReactCarouselControls = (controlArrowsEle, tagName, nextArrowClass, prevArrowClass, addTabIndex) => {

    var prevArrowIcon = document.createElement(tagName);
    var nextArrowIcon = document.createElement(tagName);
    nextArrowIcon.className = nextArrowClass;
    prevArrowIcon.className = prevArrowClass;
    prevArrowIcon.setAttribute('aria-hidden', 'true');
    nextArrowIcon.setAttribute('aria-hidden', 'true');

    /* Access button controls */
    let controlArrows = controlArrowsEle;
    let index = 0;
    /* Run loop to add accessibility and detail to buttons */

    for (index; index < controlArrows.length; index += 1) {
        var buttonLabel = (controlArrows[index].className.match(/prev/)) ? "Previous Slide" : "Next Slide";
        controlArrows[index].setAttribute('role', 'link');
        if (addTabIndex) {
            controlArrows[index].setAttribute('tabindex', '0');
        }
        controlArrows[index].setAttribute('aria-hidden', 'false');
        controlArrows[index].setAttribute('aria-label', buttonLabel);
        if (controlArrows[index].classList.contains('control-prev') || controlArrows[index].classList.contains('carousel-control-prev')) {
            controlArrows[index].appendChild(prevArrowIcon);
        } else {
            controlArrows[index].appendChild(nextArrowIcon);
        }
    }


};